'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import styled from 'foundations-theming/utils';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { jsx as _jsx } from "react/jsx-runtime";
const FavoritesContainer = styled.div.withConfig({
  displayName: "FavoritesAccordion__FavoritesContainer",
  componentId: "sc-1hi3g0v-0"
})(["display:inline-flex;"]);
const FavoriteSquatch = styled.div.withConfig({
  displayName: "FavoritesAccordion__FavoriteSquatch",
  componentId: "sc-1hi3g0v-1"
})(({
  theme,
  $backgroundColor
}) => ({
  display: 'inline-block',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: $backgroundColor,
  height: '15px',
  width: '15px',
  borderRadius: theme.borderRadius['100'],
  boxShadow: '0 0 2px #808080 inset',
  cursor: 'pointer',
  '&:not(:last-child)': {
    marginRight: theme.space['200']
  }
}));
class FavoritesAccordion extends Component {
  onClickFavorite(hex) {
    const {
      onSelectColor
    } = this.props;
    onSelectColor({
      hex
    });
  }
  render() {
    const {
      favorites = []
    } = this.props;
    if (favorites.length <= 0) return null;
    const favoritesComponents = favorites.map((color, index) => {
      const handleClick = () => {
        this.onClickFavorite(color);
      };

      // @bend-expect trellis-tokenized
      return /*#__PURE__*/_jsx(FavoriteSquatch, {
        "data-test-id": "favorites-accordion-squatch",
        onClick: handleClick,
        $backgroundColor: color
      }, `favorite-${index}`);
    });
    return /*#__PURE__*/_jsx(AccordionItem, {
      "data-test-id": "favorites-accordion",
      defaultOpen: true,
      flush: true,
      title: I18n.text('colorPicker.favorites'),
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(FavoritesContainer, {
        children: favoritesComponents
      })
    });
  }
}
FavoritesAccordion.propTypes = {
  favorites: PropTypes.arrayOf(PropTypes.string),
  onSelectColor: PropTypes.func.isRequired
};
export default FavoritesAccordion;